module.exports = __webpack_public_path__ + "c5db1fa8a641916d875358d2b6595bdf.svg";